import { ResponseError } from '@backstage/errors';

class AzureDevOpsClient {
  discoveryApi;
  fetchApi;
  constructor(options) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }
  async getRepoBuilds(projectName, repoName, host, org, options) {
    const queryString = new URLSearchParams();
    if (options?.top) {
      queryString.append("top", options.top.toString());
    }
    if (host) {
      queryString.append("host", host);
    }
    if (org) {
      queryString.append("org", org);
    }
    const urlSegment = `repo-builds/${encodeURIComponent(
      projectName
    )}/${encodeURIComponent(repoName)}?${queryString}`;
    const items = await this.get(urlSegment);
    return { items };
  }
  async getGitTags(projectName, repoName, entityRef, host, org) {
    const queryString = new URLSearchParams();
    if (host) {
      queryString.append("host", host);
    }
    if (org) {
      queryString.append("org", org);
    }
    queryString.append("entityRef", entityRef);
    const urlSegment = `git-tags/${encodeURIComponent(
      projectName
    )}/${encodeURIComponent(repoName)}?${queryString}`;
    const items = await this.get(urlSegment);
    return { items };
  }
  async getPullRequests(projectName, repoName, entityRef, host, org, options) {
    const queryString = new URLSearchParams();
    if (options?.top) {
      queryString.append("top", options.top.toString());
    }
    if (options?.status) {
      queryString.append("status", options.status.toString());
    }
    if (options?.teamsLimit) {
      queryString.append("teamsLimit", options.teamsLimit.toString());
    }
    if (host) {
      queryString.append("host", host);
    }
    if (org) {
      queryString.append("org", org);
    }
    queryString.append("entityRef", entityRef);
    const urlSegment = `pull-requests/${encodeURIComponent(
      projectName
    )}/${encodeURIComponent(repoName)}?${queryString}`;
    const items = await this.get(urlSegment);
    return { items };
  }
  getDashboardPullRequests(projectName, teamsLimit) {
    const queryString = new URLSearchParams();
    queryString.append("top", "100");
    if (teamsLimit) {
      queryString.append("teamsLimit", teamsLimit.toString());
    }
    const urlSegment = `dashboard-pull-requests/${projectName}?${queryString}`;
    return this.get(urlSegment);
  }
  getAllTeams(limit) {
    const queryString = new URLSearchParams();
    if (limit) {
      queryString.append("limit", limit.toString());
    }
    let urlSegment = "all-teams";
    if (queryString.toString()) {
      urlSegment += `?${queryString}`;
    }
    return this.get(urlSegment);
  }
  getUserTeamIds(userId) {
    return this.get(`users/${userId}/team-ids`);
  }
  async getBuildRuns(projectName, entityRef, repoName, definitionName, host, org, options) {
    const queryString = new URLSearchParams();
    queryString.append("entityRef", entityRef);
    if (repoName) {
      queryString.append("repoName", repoName);
    }
    if (host) {
      queryString.append("host", host);
    }
    if (org) {
      queryString.append("org", org);
    }
    if (definitionName) {
      const definitionNames = definitionName.split(",");
      if (definitionNames.length > 1) {
        const buildRuns = [];
        for (const name of definitionNames) {
          queryString.set("definitionName", name.trim());
          if (options?.top) {
            queryString.set("top", options.top.toString());
          }
          const urlSegment2 = `builds/${encodeURIComponent(
            projectName
          )}?${queryString}`;
          const items2 = await this.get(urlSegment2);
          buildRuns.push(...items2);
        }
        return { items: buildRuns };
      }
      queryString.append("definitionName", definitionName.trim());
    }
    if (options?.top) {
      queryString.append("top", options.top.toString());
    }
    const urlSegment = `builds/${encodeURIComponent(
      projectName
    )}?${queryString}`;
    const items = await this.get(urlSegment);
    return { items };
  }
  async getReadme(opts) {
    const queryString = new URLSearchParams();
    if (opts.host) {
      queryString.append("host", opts.host);
    }
    if (opts.org) {
      queryString.append("org", opts.org);
    }
    if (opts.path) {
      queryString.append("path", opts.path);
    }
    queryString.append("entityRef", opts.entityRef);
    return await this.get(
      `readme/${encodeURIComponent(opts.project)}/${encodeURIComponent(
        opts.repo
      )}?${queryString}`
    );
  }
  async getBuildRunLog(projectName, entityRef, buildId, host, org) {
    const queryString = new URLSearchParams();
    queryString.append("entityRef", entityRef);
    if (host) {
      queryString.append("host", host);
    }
    if (org) {
      queryString.append("org", org);
    }
    const urlSegment = `builds/${encodeURIComponent(
      projectName
    )}/build/${buildId}/log?${queryString}`;
    return await this.get(urlSegment);
  }
  async get(path) {
    const baseUrl = `${await this.discoveryApi.getBaseUrl("azure-devops")}/`;
    const url = new URL(path, baseUrl);
    const response = await this.fetchApi.fetch(url.toString());
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return response.json();
  }
}

export { AzureDevOpsClient };
//# sourceMappingURL=AzureDevOpsClient.esm.js.map
